import { PlayerApi } from "../common/atsApi";

class TournamentApi {
  constructor() {
    this.api = new PlayerApi("tournament");
  }

  getTournaments = () => this.api.getRequest("");

  getTournament = (eventId, version) => this.api.getRequest(`${eventId}/${version}`);

  postNewRound = (eventId, data) => this.api.postRequest(`${eventId}/new-round`, data);

  postNewScore = (eventId, data) => this.api.postRequest(`${eventId}/new-score`, data);
}

export default new TournamentApi();
